import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToPlatformActivity,
  mapApiResourceToPlatformBreakdown,
  mapApiResourceToPlatformGrowth,
  mapApiResourceToPlatformMetricsSummary,
  type PlatformActivity,
  type PlatformActivityApiResource,
  type PlatformBreakdown,
  type PlatformBreakdownApiResource,
  type PlatformGrowth,
  type PlatformGrowthApiResource,
  type PlatformMetricsSummary,
  type PlatformMetricsSummaryApiResource,
} from './platformMetricsApi.types';

export async function fetchPlatformMetricsSummary(): Promise<PlatformMetricsSummary> {
  const response = await httpClient.get<PlatformMetricsSummaryApiResource>(
    '/platform/metrics/summary'
  );
  return mapApiResourceToPlatformMetricsSummary(response.data);
}

export async function fetchPlatformGrowth(): Promise<PlatformGrowth> {
  const response = await httpClient.get<PlatformGrowthApiResource>('/platform/metrics/growth');
  return mapApiResourceToPlatformGrowth(response.data);
}

export async function fetchPlatformActivity(): Promise<PlatformActivity> {
  const response = await httpClient.get<PlatformActivityApiResource>('/platform/metrics/activity');
  return mapApiResourceToPlatformActivity(response.data);
}

export async function fetchPlatformBreakdown(): Promise<PlatformBreakdown> {
  const response = await httpClient.get<PlatformBreakdownApiResource>('/platform/metrics/breakdown');
  return mapApiResourceToPlatformBreakdown(response.data);
}
